import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { backPlate, backPlateColors } from "./defaults";
import Choices from "../Choices";
import findImages from "./findImages";
import { Image, Transformation } from "cloudinary-react";
import { Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useBackplateSelector from "./useBackplateSelector";

const RowLayoutLeftDivide = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const RowLayoutSpace = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
}));

function PivotBackPlateAccordian() {
  const {
    handleClick,
    handleClickColor,
    pivotBackPlate,
    pivotBackPlateColor
  } = useBackplateSelector();

  return (
    <ReusableAccordian
      accordionName="shootBolt"
      heading="Back Plate"
      secondaryHeading="Select Back Plate"
      colOrRow="col"
    >
      <RowLayout>
        <InfoIcon color="primary" style={{ marginRight: 10 }} />

        <Typography>Thumbturn Finish will match Back Plate Finish</Typography>
      </RowLayout>

      <RowLayout>
        <ColLayout>
          <Typography style={{ fontWeight: "bold" }}>Back Plate</Typography>

          <RowLayoutSpace>
            {backPlate.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={
                    state.label === pivotBackPlate ? "filled" : "outlined"
                  }
                  checkMark={state.label === pivotBackPlate}
                  wide={true}
                />
              </div>
            ))}
          </RowLayoutSpace>
        </ColLayout>

        <ColLayout>
          <Typography style={{ fontWeight: "bold" }}>
            Back Plate Finish
          </Typography>

          <RowLayoutLeftDivide>
            {backPlateColors.map((state) => (
              <div key={state.id} onClick={() => handleClickColor(state.label)}>
                <Choices
                  label={state.label}
                  variant={
                    state.label === pivotBackPlateColor ? "filled" : "outlined"
                  }
                  checkMark={state.label === pivotBackPlateColor}
                  wide={true}
                />
              </div>
            ))}
          </RowLayoutLeftDivide>
        </ColLayout>
      </RowLayout>

      {pivotBackPlate && (
        <RowLayout>
          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId={findImages(pivotBackPlate, pivotBackPlateColor || "")}
            style={{ marginRight: 20 }}
          >
            <Transformation width="150" crop="scale" />
          </Image>

          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId="PivotHardware/thumbturn"
            style={{ marginLeft: 20 }}
          >
            <Transformation width="200" crop="scale" />
          </Image>
        </RowLayout>
      )}
    </ReusableAccordian>
  );
}

export default memo(PivotBackPlateAccordian);
